import React, { useState } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Divider, Typography } from '@material-ui/core'
import { CoreButton } from 'src/components/core'
import styles from './styles'

const Instruction = props => {
  const {
    data,
    sourceText,
    classes,
    aiInstructionConfirmSelection,
    handleCancel,
  } = props
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [selectedData, setSelectedData] = useState(null)

  const handleSelect = (item, index) => {
    setSelectedIndex(index)
    setSelectedData(item)
  }

  return (
    <div className={classes.content}>
      <div>
        <Typography className={classes.header}>
          Choose an Interactive Activity
        </Typography>
        <Typography className={classes.note}>
          Choose an activity that best fits your content to create an engaging
          learning experience. <br></br>Activities use only text from the
          corresponding page.
        </Typography>
      </div>
      {data.suggestions.map((item, index) => (
        <div
          key={index}
          className={classes.selectContainer}
          onClick={() => handleSelect(item, index)}
          style={{
            border:
              selectedIndex === index
                ? '1px solid var(--mcg-blue, #015FFB)'
                : '1px solid var(--Gray-Lighter, #E5E7EB)',
            boxShadow:
              selectedIndex === index
                ? '0px 0px 2px 0px rgba(145, 158, 171, 0.12), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)'
                : 'none',
            cursor: 'pointer',
          }}
        >
          <div className={classes.titleContainer}>
            <Typography className={classes.headerSelect}>
              {item.title}
            </Typography>
          </div>
          <div className={classes.badgeContainer}>
            <div className={classes.badgeLeft}>
              <Typography className={classes.badgeTitle}>
                {item.interaction_type}
              </Typography>
            </div>
            <div className={classes.badgeRight}>
              <Typography className={classes.badgeTitle}>
                {item.technical_complexity}
              </Typography>
            </div>
          </div>
          <div className={classes.descriptionContainer}>
            <Typography className={classes.description}>
              {item.description}
            </Typography>
          </div>
          {selectedIndex === index && (
            <>
              <div className={classes.dividerContainer}>
                <Divider className={classes.divider} />
              </div>
              <div>
                <Typography className={classes.description}>
                  <span className={classes.educationalText}>
                    Educational value:{' '}
                  </span>
                  {item.educational_value}
                </Typography>
              </div>
              <div className={classes.descriptionContainer}>
                <Typography className={classes.description}>
                  <span className={classes.educationalText}>Elements: </span>
                  {item.elements}
                </Typography>
              </div>
            </>
          )}
        </div>
      ))}
      <div className={classes.buttonContainer}>
        <div className={classes.textSection}>
          <Typography className={classes.note}>
            AI assistance can make mistakes; please double-check critical
            information.
          </Typography>
        </div>
        <div className={classes.buttonGroup}>
          <CoreButton
            onClick={() => handleCancel()}
            size="medium"
            color="secondary"
            variant="text"
          >
            Cancel
          </CoreButton>
          <CoreButton
            size="medium"
            disabled={!selectedData}
            color="primary"
            variant="contained"
            onClick={() =>
              aiInstructionConfirmSelection(selectedData, sourceText)
            }
          >
            Confirm selection
          </CoreButton>
        </div>
      </div>
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(Instruction)
